<template>
  <div class="max-w-4xl mx-auto space-y-6">
    <!-- Driver info -->
    <div class="p-6 bg-white border border-gray-200 shadow-sm rounded-2xl">
      <div class="flex items-center mb-6 space-x-1 text-gray-500">
        <span class="text-base material-icons-round">account_circle</span>
        <span class="text-xs font-semibold tracking-widest uppercase">Driver Info</span>
      </div>

      <div class="flex flex-col items-center gap-8 sm:flex-row sm:items-start">
        <img
          :src="driver.profileImage"
          v-image-preview
          :alt="driver.firstName"
          class="flex-shrink-0 object-cover w-40 h-40 p-1.5 border rounded-full shadow-sm bg-taxiye-100 border-taxiye-200"
        />

        <div class="grid flex-1 w-full grid-cols-1 gap-x-8 gap-y-5 sm:grid-cols-2">
          <div>
            <p class="text-xs font-semibold tracking-wider text-gray-500 uppercase">Name</p>
            <p class="mt-0.5 text-lg text-gray-900">{{ driver.firstName }} {{ driver.lastName }}</p>
          </div>
          <div>
            <p class="text-xs font-semibold tracking-wider text-gray-500 uppercase">Email</p>
            <p class="mt-0.5 text-lg text-gray-900">{{ driver.email || "N/A" }}</p>
          </div>
          <div>
            <p class="text-xs font-semibold tracking-wider text-gray-500 uppercase">Contact Number</p>
            <p class="mt-0.5 text-lg text-gray-900">{{ driver.phoneNumber || "N/A" }}</p>
          </div>
          <div>
            <p class="text-xs font-semibold tracking-wider text-gray-500 uppercase">City</p>
            <p class="mt-0.5 text-lg text-gray-900">{{ driver.city || "N/A" }}</p>
          </div>
          <div>
            <p class="text-xs font-semibold tracking-wider text-gray-500 uppercase">Plate Number</p>
            <p class="mt-0.5 text-lg text-gray-900">{{ vehicle.plateNumber || "N/A" }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Availability -->
    <div class="p-6 bg-white border border-gray-200 shadow-sm rounded-2xl">
      <div class="flex items-center mb-5 space-x-1 text-gray-500">
        <span class="text-base material-icons-round">schedule</span>
        <span class="text-xs font-semibold tracking-widest uppercase">Availability</span>
        <span class="pl-2 text-xs font-normal normal-case text-gray-400">Online hours this week</span>
      </div>

      <div class="grid grid-cols-7 gap-2 sm:gap-3">
        <div
          v-for="dow in dows"
          :key="dow.label"
          class="overflow-hidden text-center border rounded-xl"
          :class="dow.isToday ? 'border-green-300' : 'border-gray-200'"
        >
          <div
            class="py-1.5 text-xs font-semibold tracking-wider uppercase"
            :class="{
              'bg-green-100 text-green-700': dow.isToday,
              'bg-gray-50 text-gray-400': dow.isFuture,
              'bg-gray-50 text-gray-500': !dow.isToday && !dow.isFuture,
            }"
          >
            {{ dow.label }}
          </div>
          <div
            class="flex items-center justify-center px-1 py-4 text-sm"
            :class="dow.isFuture ? 'text-gray-300' : (dow.isToday ? 'text-green-700 font-medium' : 'text-gray-700')"
          >
            {{ dow.isFuture ? '-' : (stats[dow.name] ? secondsToHms(stats[dow.name].onlineHours) : '-') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const dows = [
  { label: "sun", name: "sunday" },
  { label: "mon", name: "monday" },
  { label: "tue", name: "tuesday" },
  { label: "wed", name: "wednesday" },
  { label: "thu", name: "thursday" },
  { label: "fri", name: "friday" },
  { label: "sat", name: "saturday" },
]
export default {
  data() {
    return {
      driver: {
        firstName: "",
        lastName: "",
        email: "",
        phoneNumber: "",
        profileImage: "",
        city: "",
        vehicleType: "",
        businessLicense: "",
        drivingLicense: "",
        representationPaper: "",
      },
      vehicle: {
        plateNumber: "",
      },
      // dows: dows.map((x, i) => ({
      //   label: x,
      //   isFuture: i > new Date().getDay(), 

      //   isToday: i === new Date().getDay()
      // }))
      dows: dows.map((_, i) => {
        // const dow = dows[(i + 1 +dows.length + new Date().getDay()) % dows.length]
        const dow = dows[i]
        return {
          ...dow,
          // isToday: i === 6
          isToday: i === new Date().getDay(),
          isFuture: i > new Date().getDay()
        }
      }),
      stats: {
        sunday: 0,
        monday: 0,
        tuesday: 0,
        wednesday: 0,
        thursday: 0,
        friday: 0,
        saturday: 0,
      }
      // dows: [...dows.slice(0, new Date().getDay()), ...dows.slice(new Date().getDay())]
    };
  },
  created() {
    this.getDriver();
  },
  methods: {
    getDriver() {
      console.log("/drivers/" + this.$route.params.id);
      this.$misc
        .get("/drivers/" + this.$route.params.id)
        .then((response) => {
          console.log(response.data.driver);
          this.driver = response.data.driver;
          if (response.data.vehicle)
            this.vehicle = response.data.vehicle;
        })
        .catch((err) => console.log(err));
      this.$misc
        .get("/drivers/stats/" + this.$route.params.id)
        .then((response) => {
          this.stats = response.data;
        })
        .catch((err) => console.log(err));
    },
    secondsToHms(d) {
      if (d == 0) {
        return '0'
      }
      d = Number(d);
      var h = Math.floor(d / 3600);
      var m = Math.floor(d % 3600 / 60);
      var s = Math.floor(d % 3600 % 60);

      var hDisplay = h > 0 ? h + (h == 1 ? " hr, " : " hrs, ") : "";
      var mDisplay = m > 0 ? m + (m == 1 ? " min, " : " mins, ") : "";
      var sDisplay = s > 0 ? s + (s == 1 ? " sec" : " secs") : "";
      return hDisplay + mDisplay + sDisplay;
    }
  },
};
</script>
